import { render, staticRenderFns } from "./addFollowCost.vue?vue&type=template&id=427da219&scoped=true"
import script from "./addFollowCost.vue?vue&type=script&lang=js"
export * from "./addFollowCost.vue?vue&type=script&lang=js"
import style0 from "./addFollowCost.vue?vue&type=style&index=0&id=427da219&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427da219",
  null
  
)

export default component.exports